import React, { Component } from 'react';
import RadioButton from '../../components/Buttons/RadioButton';
import TextMap from '../../helpers/TextMap';
import i18n from '../../i18n';

import './LanguageOptions.scss';

class LanguageOptions extends Component {
  constructor(props) {
    super(props);
    this.textMap = new TextMap();
    this.currentLanguage = i18n.getCurrentLanguage();

    this.state = {
      languageOptions: [
        { name: 'English', abbreviation: 'en-US', selected: this.currentLanguage == 'en-US' || !this.currentLanguage },
        { name: 'Español', abbreviation: 'es', selected: this.currentLanguage == 'es' },
        { name: 'Português', abbreviation: 'pt', selected: this.currentLanguage == 'pt' },
        { name: 'Pусский', abbreviation: 'ru', selected: this.currentLanguage == 'ru' },
      ],
    };
  }

  async handleSelectLanguage(selectedOption, checked) {
    const languageOptions = this.state.languageOptions.map((option) => {
      if (selectedOption.abbreviation == option.abbreviation) {
        option.selected = true;
      }
      else {
        option.selected = false;
      }
      return option;
    });
    this.currentLanguage = selectedOption.abbreviation;
    this.setState({ languageOptions });
    await i18n.changeLanguage(selectedOption.abbreviation);
  }

  createOptions() {
    return this.state.languageOptions.map((option, index) => {
      return (
        <li className={'language-option' + (index == 0 ? ' language-option--first' : '')}>
          <p className='language-option__text'>
            { option.name }
          </p>
          <RadioButton 
            id={ option.name } 
            name={ option.name } 
            checked={ option.selected }
            handleOnChange={ (checked) => { this.handleSelectLanguage(option, checked); } }
          />
        </li>
      );
    });
  }

  render() {
    return (
      <form className='LanguageOptions'>
        <ul className='language-options-container'>
          { this.createOptions() }
        </ul>
      </form>
    );
  }
}

export default LanguageOptions;



// WEBPACK FOOTER //
// ./src/components/LanguageOptions/index.js